import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
  ul {
    margin: 0;
    padding: 0px 0px 0px 0px;
    list-style: none;
  }
  .featured-puff{
    padding: 24px 16px 16px 0px;
    display: grid;
    grid-gap: 24px;
    grid-auto-flow: column;
    grid-auto-columns: 300px;
    overflow: auto;
  }

  .featured-puff::-webkit-scrollbar { /* make scrollbar invisible even when it appears */
    width: 0px;
    background: transparent;
    height: 0px;
  }
  .featureTab-Wrapper{
    top: 60%;
    position: relative;
    width: 100%;
    z-index: 9;
    padding-top: 16px;
  }
  .footer-wrapper{
    top: 40%;
    position: absolute;
    width: 100%;
    z-index: 9;
  }
  .sponsor{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  p {
    color: ${colors.primaryText};
    font-display:optional;
  }
  .featured {
    margin-top: 24px;
  }

  .featured-tab-item {
    display: block;
  }
  .recommended {
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
  }
  .AdSlot-container {
    margin: 0 auto;
    padding-top: 68px;
    text-align: center;
  }

  .mpu-container {
    margin-left:16px;
    margin-bottom: 32px;
  }

  .my-list-button {
    height: 48px;
  }

  @media(min-width: 768px) {
    .featured {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-left: 16px;
      margin-right: 16px;
    }
    .mpu-container {
      margin-left: 24px;
    }
    .featureTab-Wrapper{
      position: absolute;
        top: 85%;
        padding-top: 0px;
    }
    .featured-videos {
      width: ${(7 / 12) * 100}%;
      padding-right: 16px;
    }
    .featured-sidebar {
      width: ${(5 / 12) * 100}%;
      align-items: flex-end;
      max-width: 340px;
    }
    .featured-tabs-content {
      display: flex;
      flex-grow: 1;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .tab-loader {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
    .recommended h2 {
      margin-bottom: 0.5em;
    }
  }

  @media(min-width: 1024px) {
    .recommended {
      margin-left: 0px;
      margin-right: 32px;
    }
    .featured-puff{
      padding-top: 24px;
      display: flex;
      flex-direction: row;
      gap: 24px;
    }
    .featureTab-Wrapper{
        top: 65%;
    }
    .mpu-container {
      margin-left: 24px;
    }
    .AdSlot-container {
      margin: 0 auto;
      padding-top: 68px;
      text-align: center;
    }
    .featured {
      margin-left: 32px;
      margin-right: 32px;
    }
    .featured-videos {
      width: auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: start;
      padding-right: 16px;
    }
    :global(.ie .featured-videos) {
      flex-basis: calc(100% - 300px);
    }
    .featured-episode {
      flex: 2;
      padding-right: 16px;
    }
    .featured-shortform {
      flex: 1;
    }
    .featured-sidebar {
      max-width: 300px;
    }

    .featured-tabs-content {
      justify-content: flex-start;
    }
    .featured-tab-item {
      // flex-basis: calc(-10.666px + 33.333%);
      // max-width: calc(-10.666px + 33.333%);
      // margin-left: 8px;
      // margin-right: 8px;
    }

    .featured-tab-item:nth-of-type(3n + 1) {
     // margin-left: 0;
    }
    .featured-tab-item:nth-of-type(3n + 3) {
    //  margin-right: 0;
    }
  }
  @media(min-width: 1200px){
    .featureTab-Wrapper{
        top: 62%;
    }

    .AdSlot-container {
      margin: 0 auto;
      padding-top: 68px;
      text-align: center;
    }

    .mpu-container {
      margin-left: 48px;
    }
  }
`
